import { CTA, ProviderLogo, MarketPlace } from '@amzn/fire-tv-campaign-automation-service';
import { TEXT_BASED_TITLE_DESCRIPTION_LENGTH } from 'src/constants';
import { LogoTextState } from 'src/types';
import { PropUtils } from 'src/utils/PropUtils';

import { CMSConfig } from './campaignMetadataConfig';

type FieldType = 'text' | 'dropdown';

interface BaseFieldConfig {
  type: FieldType;
  label: string;
  placeholder: string;
  dataTestId: string;
  required?: boolean;
}

export interface TextFieldConfig extends BaseFieldConfig {
  type: 'text';
  maxLength?: number;
}

export interface DropdownFieldConfig extends BaseFieldConfig {
  type: 'dropdown';
  options: (marketplace: string) => Array<{ name: string; value: string }>;
}

export type FieldConfig = TextFieldConfig | DropdownFieldConfig;

/**
 * Configuration for LogoTextInput form fields
 * Defines all field properties including type, label, validation, and options
 */
export const LOGO_TEXT_INPUT_CONFIG: Record<keyof LogoTextState, FieldConfig> = {
  logoTitle: {
    type: 'text',
    label: 'Logo Title',
    placeholder: 'Enter Logo Title',
    dataTestId: 'logo-title-input',
    maxLength: TEXT_BASED_TITLE_DESCRIPTION_LENGTH.LOGO_TITLE_MAX_LENGTH,
    required: true,
  },
  logoDescription: {
    type: 'text',
    label: 'Logo Description',
    placeholder: 'Enter Logo Description',
    dataTestId: 'logo-description-input',
    maxLength: TEXT_BASED_TITLE_DESCRIPTION_LENGTH.LOGO_DESCRIPTION_MAX_LENGTH,
    required: true,
  },
  cta: {
    type: 'dropdown',
    label: 'Call To Action',
    placeholder: 'Select CTA',
    dataTestId: 'cta-selector',
    options: (marketplace: string) =>
      PropUtils.createOptionsFromEnumValues(CMSConfig.CTA[marketplace as MarketPlace]),
    required: true,
  },
  providerLogo: {
    type: 'dropdown',
    label: 'Provider Logo',
    placeholder: 'Select Provider Logo',
    dataTestId: 'provider-logo-selector',
    options: () =>
      PropUtils.getTitleCasedOptions(
        PropUtils.getOptionsWithUnderscoresRemoved(
          PropUtils.createOptionsFromEnumValues(CMSConfig.PROVIDER_LOGO, ProviderLogo),
        ),
      ),
    required: true,
  },
};
